import { render, staticRenderFns } from "./ScreenBodegaReportes.vue?vue&type=template&id=82c6b22e&scoped=true"
import script from "./ScreenBodegaReportes.vue?vue&type=script&lang=js"
export * from "./ScreenBodegaReportes.vue?vue&type=script&lang=js"
import style0 from "./ScreenBodegaReportes.vue?vue&type=style&index=0&id=82c6b22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c6b22e",
  null
  
)

export default component.exports